import { z } from 'zod';

// Unified UserType - shared across registration components
// IMPORTANT: Keep in sync with user-type-selector.tsx
export type UserType = 'dc_member' | 'visitor';

// DC Member registration schema
export const dcMemberSchema = z.object({
  userType: z.literal('dc_member'),
  firstName: z.string().min(2, 'First name must be at least 2 characters'),
  surname: z.string().min(2, 'Surname must be at least 2 characters'),
  phoneNumber: z.string().min(10, 'Phone number must be at least 10 characters'),
  country: z.string().min(1, 'Please select your country'),
  dcMembershipId: z.string().optional(),
  email: z.string().email('Please enter a valid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ['confirmPassword'],
});

// Non-DC Member registration schema
export const nonDcMemberSchema = z.object({
  userType: z.literal('visitor'),
  firstName: z.string().min(2, 'First name must be at least 2 characters'),
  surname: z.string().min(2, 'Surname must be at least 2 characters'),
  phoneNumber: z.string().min(10, 'Phone number must be at least 10 characters'),
  country: z.string().min(1, 'Please select your country'),
  ministryName: z.string().min(2, 'Ministry name must be at least 2 characters'),
  ministryState: z.string().min(2, 'Ministry state must be at least 2 characters'),
  ministryCountry: z.string().min(1, 'Please select your ministry country'),
  email: z.string().email('Please enter a valid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ['confirmPassword'],
});

// Combined registration schema
export const registrationSchema = z.discriminatedUnion('userType', [
  dcMemberSchema,
  nonDcMemberSchema,
]);

export type DcMemberFormValues = z.infer<typeof dcMemberSchema>;
export type NonDcMemberFormValues = z.infer<typeof nonDcMemberSchema>;
export type RegistrationFormValues = z.infer<typeof registrationSchema>;

// Country list for dropdown
export const countries = [
  { value: 'NG', label: 'Nigeria' },
  { value: 'US', label: 'United States' },
  { value: 'UK', label: 'United Kingdom' },
  { value: 'CA', label: 'Canada' },
  { value: 'AU', label: 'Australia' },
  { value: 'GH', label: 'Ghana' },
  { value: 'KE', label: 'Kenya' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'UG', label: 'Uganda' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'SN', label: 'Senegal' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CI', label: 'Ivory Coast' },
  { value: 'TG', label: 'Togo' },
  { value: 'BJ', label: 'Benin' },
  { value: 'LR', label: 'Liberia' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'GM', label: 'Gambia' },
  { value: 'OTHER', label: 'Other' },
];

// Ministry country list (same as countries)
export const ministryCountries = countries;
